import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Space } from '../Space/Space';
import { Typography } from '../Typography/Typography';
/**
 * Small label added to the top of the input.
 */
export const InputLabel = ({ children, label }) => {
    return (_jsxs(Space, { direction: 'vertical', size: 'xs', children: [_jsx(Typography.Text, { fullWidth: true, size: 'sm', weight: 'regular', color: 'neutral-400', children: label }), children] }));
};
